import pako from 'pako';

function deserializeBase64ToMask(serializedData) {
    // Extract the base64 string from the serialized data
    const maskBase64Str = serializedData.data;

    // Decode the base64 string to get the compressed mask bytes
    const compressedMaskBytes = Uint8Array.from(atob(maskBase64Str), c => c.charCodeAt(0));

    // Decompress the compressed mask bytes
    const maskBytes = pako.inflate(compressedMaskBytes);

    // Get the shape and dtype from the serialized data
    const maskShape = serializedData.shape;
    const maskDtype = serializedData.dtype;

    // Convert the byte array to the appropriate typed array based on dtype
    let mask;
    switch (maskDtype) {
        case 'uint8':
            mask = new Uint8Array(maskBytes.buffer);
            break;
        case 'int8':
            mask = new Int8Array(maskBytes.buffer);
            break;
        case 'uint16':
            mask = new Uint16Array(maskBytes.buffer);
            break;
        case 'int16':
            mask = new Int16Array(maskBytes.buffer);
            break;
        case 'uint32':
            mask = new Uint32Array(maskBytes.buffer);
            break;
        case 'int32':
            mask = new Int32Array(maskBytes.buffer);
            break;
        case 'float32':
            mask = new Float32Array(maskBytes.buffer);
            break;
        case 'float64':
            mask = new Float64Array(maskBytes.buffer);
            break;
        default:
            throw new Error('Unsupported dtype');
    }

    // Reshape the typed array to the specified shape
    const reshapedMask = [];
    let index = 0;

    function reshape(arr, shape) {
        if (shape.length === 1) {
            return arr.slice(index, index += shape[0]);
        }
        const size = shape.reduce((a, b) => a * b) / shape[0];
        const newArr = [];
        for (let i = 0; i < shape[0]; i++) {
            newArr.push(reshape(arr, shape.slice(1)));
        }
        return newArr;
    }

    return reshape(mask, maskShape);
}

export {deserializeBase64ToMask};
